var _path, _path2, _path3, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBrowsesafe(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.5H68C74.3513 0.5 79.5 5.64873 79.5 12V68C79.5 74.3513 74.3513 79.5 68 79.5H12C5.64873 79.5 0.5 74.3513 0.5 68V12C0.5 5.64873 5.64873 0.500001 12 0.5Z",
    fill: "url(#paint0_linear_18_2252)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.5H68C74.3513 0.5 79.5 5.64873 79.5 12V68C79.5 74.3513 74.3513 79.5 68 79.5H12C5.64873 79.5 0.5 74.3513 0.5 68V12C0.5 5.64873 5.64873 0.500001 12 0.5Z",
    stroke: "url(#paint1_linear_18_2252)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_2252)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18_2252",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 19,
    width: 42,
    height: 43
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61 19.25H19V61.25H61V19.25Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18_2252)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 32.8125C36.6925 32.8125 36.0625 34.195 36.0625 36.75V37.835H43.9375V36.75C43.9375 34.195 43.3075 32.8125 40 32.8125Z",
    fill: "#34D399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0002 45.6757C41.0633 45.6757 41.9252 44.8138 41.9252 43.7507C41.9252 42.6876 41.0633 41.8257 40.0002 41.8257C38.9371 41.8257 38.0752 42.6876 38.0752 43.7507C38.0752 44.8138 38.9371 45.6757 40.0002 45.6757Z",
    fill: "#34D399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 22.75C30.34 22.75 22.5 30.59 22.5 40.25C22.5 49.91 30.34 57.75 40 57.75C49.66 57.75 57.5 49.91 57.5 40.25C57.5 30.59 49.66 22.75 40 22.75ZM49.415 44.625C49.415 48.475 48.225 49.665 44.375 49.665H35.625C31.775 49.665 30.585 48.475 30.585 44.625V42.875C30.585 39.8825 31.3025 38.5 33.4375 38.0275V36.75C33.4375 35.1225 33.4375 30.1875 40 30.1875C46.5625 30.1875 46.5625 35.1225 46.5625 36.75V38.0275C48.6975 38.5 49.415 39.8825 49.415 42.875V44.625Z",
    fill: "#34D399"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18_2252",
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#041D15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18_2252",
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 69.5833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34D399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_2252"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(20 20.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBrowsesafe);
export default __webpack_public_path__ + "static/media/icon-browsesafe.6138aef07f063c0d7ff8e26d61aef3d0.svg";
export { ForwardRef as ReactComponent };